if (!customElements.get('ui-tabbed-products')) {
  class UITabbedProducts extends HTMLElement {
    constructor() {
      super();
      /** @type {NodeListOf<HTMLButtonElement>} */
      this.tabButtons = this.querySelectorAll('.tabbed-products__tab-btn');
    }

    connectedCallback() {
      this.tabButtons.forEach((button, key) => {
        button.addEventListener('click', this.onTabButtonClick.bind(this));
        button.setAttribute('data-index', key.toString());
      });
    }

    /**
     * @param {MouseEvent} event
     */
    onTabButtonClick(event) {
      /** @type {HTMLButtonElement} */
      // @ts-ignore
      const target = event.currentTarget;
      const activeIndex = parseInt(target.dataset.index || '');

      this.tabButtons.forEach((button, key) => {
        if (key === activeIndex) {
          button.classList.add('is-active');
        } else {
          button.classList.remove('is-active');
        }
      });
      this.querySelectorAll('.tabbed-products__tab-body').forEach(
        (el, index) => {
          if (activeIndex === index) {
            el.classList.add('is-animating');
            setTimeout(function () {
              el.classList.remove('is-animating');
              el.classList.add('is-active');
            }, 10);
          } else {
            el.classList.remove('is-active');
          }
        },
      );
    }
  }

  customElements.define('ui-tabbed-products', UITabbedProducts);
}
